import React from "react";
import { Link } from "react-router-dom";
import { convertToUrl } from "../libraries/ercLibrary";
import Rating from "./Rating";
import "./Product.css";
import { useDispatch } from "react-redux";
import { PRODUCT_DETAILS_CAMPAIGNED_RESET } from "../constants/productConstants";
import useWidth from "../hooks/useWidth";
import useGetLimitedTimeDiscountInfo from "../hooks/useGetLimitedTimeDiscountInfo";
import { calculateDisplayedPrice } from "../utils/calculateDisplayedPrice";
import IsInStock from "./PriceOffer/IsInStock";

export default function Product(props) {
  const dispatch = useDispatch();
  const width = useWidth();

  // PROPS COMING FROM HomeScreen
  const {
    product,
    cartSkuItems,
    isPending,
    createdFingerPrint,
    visitTime,

    // history,
  } = props;

  // GET LIMITED TIME DISCOUNT INFO
  const { isDiscountValid } = useGetLimitedTimeDiscountInfo(
    product,
    createdFingerPrint,
    visitTime,
    visitTime,
  );

  // RESET CAMPAIGNED PRODUCT DETAILS REDUX
  function handleResetCampaignedProduct() {
    dispatch({ type: PRODUCT_DETAILS_CAMPAIGNED_RESET });
  }

  return (
    <>
      <div
        className="w100p"
        onClick={() => {
          handleResetCampaignedProduct();
          sessionStorage.setItem("scrollId", product._id);
        }}
      >
        <div>
          <Link
            className="col-jus"
            to={`/urun/${convertToUrl(product.name)}/${product._id}?popPrice=${product.defaultPrice}`}
          >
            <img
              className="w90p rad5r"
              src={product.defaultImages[0]}
              alt={product.name}
            />
          </Link>
        </div>
        <div
          title={product.name.length > 60 ? product.name : ""}
          className="product-name"
        >
          <Link
            className="nodeco black"
            to={`/urun/${convertToUrl(product.name)}/${product._id}?popPrice=${product.defaultPrice}`}
          >
            <div className="product-card-title-wrap">
              <h3 className="product-card-title">
                {width > 600 && product.name.length > 60
                  ? `${product.name.slice(0, 61)}...`
                  : product.name}
              </h3>
            </div>
          </Link>
        </div>
        <div className="col">
          <div className="rating">
            {product.rating > 0 && (
              <Rating
                value={product.rating}
                text={` (${product.numReviews})`}
              />
            )}
          </div>
          <div className="price">
            {isPending?.isTherePending === "YES" ? (
              <>
                <strike className="fs15 marginright0-25r red-col">
                  {calculateDisplayedPrice(product.defaultPrice)}{" "}
                </strike>
                <span>
                  {calculateDisplayedPrice(product.defaultPriceGap)} TL
                </span>
              </>
            ) : cartSkuItems.length >= 1 && isDiscountValid ? (
              <>
                <strike className="fs15 marginright0-25r red-col">
                  {calculateDisplayedPrice(product.defaultPrice)} TL
                </strike>
                <span>
                  {calculateDisplayedPrice(product.defaultPriceGap)} TL
                </span>
              </>
            ) : (
              <span>{calculateDisplayedPrice(product.defaultPrice)} TL</span>
            )}
          </div>

          <IsInStock product={product} isBundleWithStock={product.isInstock} />

          <div className="w100p txtcenter">
            <Link
              to={`/urun/${convertToUrl(product.name)}/${product._id}?popPrice=${product.defaultPrice}`}
            >
              <button className="primary w95p" type="button">
                <h3 className="h3c">Şimdi İncele</h3>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
